export default __webpack_public_path__ + "static/media/optimism.829df00f.svg";